import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import {
    ButtonField,
    ButtonFieldIcon,
    CheckboxField,
    Iconsvg,
    Pagination,
    PaginationBar,
    PaginationBarLeft,
    PaginationBarRight,
    SelectField
} from '@wk/components-react16';
import GaugeChart from 'react-gauge-chart';
import {Toast} from '../../services';
import HttpService from "../../config/http.service";
import {API_URL} from "../../config/constants";
import moment from 'moment';
import PromptStudio from './model/PromptStudio';
import ConfirmPrompt from './model/ConfirmPrompt';
import AddDeleteValidationCases from './model/AddDeleteValidationCases';
import { RootState, store } from '../../store';
import { useSelector, useDispatch } from 'react-redux';
import { showLoading, hideLoading } from "../../store/authReducer";
import PromptLibraryFilter from './PromptLibraryFilter';
import FacetsFilter from './FacetsFilter';
import Tags from './Tags';
import { Privilege } from '../../config/constants/privilege';
import PromptVersionHistory from './model/PromptVersionHistory';
import DeleteConfirm from '../../components/DeleteConfirm';

const PromptLibrary = () => {
    const navigate = useNavigate();
	const dispatch = useDispatch();
    const { authUser, authProject } = useSelector((state: RootState) => state.auth);
    const [promptTab, setPromptTab] = useState(0);
    // const [viewPublished, setViewPublished] = useState(false);
    const promptObj = {
        id: null,
        name: '',
        text: '',
        promptType: null,
        jsonOutput: false,
        score: 0,
        categoryScore: null,
        tags: [],
       
    };
    const [isEditAllPrompts, setIsEditAllPrompts] = useState(false);
    const [isDeleteAllPrompts, setIsDeleteAllPrompts] = useState(false);
    const [promptList, setPromptList] = useState([] as any);
    const [facets, setFecets] = useState([] as any);
    const [prompt, setPrompt] = useState(promptObj);
    const [isOpenConfirm, setIsOpenConfirm] = useState(false);
    const [isOpenDeleteConfirm, setIsOpenDeleteConfirm] = useState(false);
    const [isPromptDeleted, setIsPromptDeleted] = useState(false);
    const [isOpenPromptStudio, setIsOpenPromptStudio] = useState(false);
    const [isLoad, setIsLoad] = useState(false);
    const [userDefinedPromptType, setUserDefinedPromptType] = useState(false);
    const [isOpenValidationCases, setIsOpenValidationCases] = useState(false);
    const [isOpenPromptVersionHistory, setIsOpenPromptVersionHistory] = useState(false);
    const [validationCases, setValidationCases] = useState({ id: null, validations: null, isShow: false});
    const [isOpenImproveScore, setIsOpenImproveScore] = useState(false);
    const [pagination, setPagination] = useState({ pageIndex: 1, pageSize: 10, pageCount: 0, totalCount: 0 });
    const [selectedPromptIds, setSelectedPromptIds] = useState([] as any[]);
    const [promptPayload, setPromptPayload] = useState({
        projectId: authProject?.id,
        page: 1,
        size: 10,
        filterText: '',
        searchField: 'name',
        promptType: [],
        createdBy: [],
        catIds: [],
        data: true,
        // isPublished: promptTab === 1 ? true : false,
        // isdraft: promptTab === 2 ? true : false,
    });

    const [searchText, setSearchText] = useState('');
    
    const isInitialPromptTabEffect = React.useRef(true);
    const isRestoringStateRef = React.useRef(false);
    const PROMPT_LIBRARY_STATE_KEY = 'promptLibraryState';

    const getPrompts = (page: number = 1, size: number = 10, tabIndex?: number) => {
    // const getPrompts = (page: number = 1, size: number = 10, clearSelection: boolean = false) => {
        dispatch(showLoading());
        const currentTab = tabIndex !== undefined ? tabIndex : promptTab;
        setPromptTab(currentTab);
        const isPublishedValue = currentTab === 1;
        promptPayload.page = page;
        promptPayload.size = size;
        promptPayload.projectId = authProject.id;
        // promptPayload.isPublished = isPublishedValue;
        // promptPayload.isdraft = currentTab === 2 ? true : false;
        let apiurl: string;
        if (currentTab === 0) {
            apiurl = API_URL.POST_ALL_PROMPTS;
        } else if (currentTab === 1) {
            apiurl = API_URL.POST_PUBLISHED_PROMPT;
        } else if (currentTab === 2) {
            apiurl = API_URL.POST_DRAFT_PROMPT;
        } else if (currentTab === 3) {
            apiurl = API_URL.POST_RECYCLE_BIN_PROMPT;
        } else {
            apiurl = API_URL.POST_ALL_PROMPTS;
        }
        HttpService.postRequest(`${apiurl}`, promptPayload).then(
            (res: any) => {
                const prompts = res.data ? res.data : [];
                setPromptList(prompts);
                // setPromptList(
                //     prompts.map((item: any) => ({
                //         ...item,
                //         isSelected: isPublishedValue ? false : selectedPromptIds.includes(item.id)
                //     }))
                // );
                // if (isPublishedValue) {
                //     setSelectedPromptIds([]);
                // }
                setSelectedPromptIds([]);
                if (res.facets) {
                    setFecets(res.facets);
                }
                setPagination({
                    pageIndex: page,
                    pageSize: size,
                    pageCount: Math.ceil(res.totalCount / size),
                    totalCount: res.totalCount
                });
                dispatch(hideLoading());
            },
            (err: any) => {
                setPromptList([]);
                setFecets([]);
                setPagination({ pageIndex: 1, pageSize: 10, pageCount: 0, totalCount: 0 });
                Toast(err.message, "error");
                dispatch(hideLoading());
            },
        )
    }

    const editPrompt = (prompt: any, score: boolean) => {
        if(promptTab === 1) {
            dispatch(showLoading());
            HttpService.getRequest(`${API_URL.GET_DRAFT_PROMPT_BY_ID}/${prompt.id}`).then(
                (res: any) => {
                    setPrompt(res);
                    dispatch(hideLoading());
                    setIsOpenPromptStudio(true);
                    setIsOpenImproveScore(score);
                },
                (err: any) => {
                    dispatch(hideLoading())
                    if(err.status === 404) { 
                        setPrompt(prompt);
                        setIsOpenPromptStudio(true);
                        setIsOpenImproveScore(score);
                    } else {
                        Toast(err.message, "error");
                    }
                }
            );
        } else {
            setPrompt(prompt);
            setIsOpenPromptStudio(true);
            setIsOpenImproveScore(score);
        }
    }

    const deletePromptConfirm = (prompt: any) => {
        setPrompt(prompt);
        setIsOpenConfirm(true);
    }

    const permenantdeletePromptConfirm = (prompt: any) => {
        setPrompt(prompt);
        setIsOpenDeleteConfirm(true);
    }
    const deleteItem = () => {
        setIsOpenDeleteConfirm(false);
        dispatch(showLoading());
        HttpService.deleteRequest(API_URL.PERMANENT_DELETE_PROMPT + "/" + prompt.id).then(
            (res: any) => {
                dispatch(hideLoading());
                Toast(`Prompt "${prompt.name}" deleted successfully.`, "success");
                setTimeout(() => {
                    getPrompts();
                }, 1000);
            },
            (err: any) => {
                dispatch(hideLoading());
                Toast(err.message, "error");
            }
        )
    }

    const restorePrompt = (prompt: any) => {
        dispatch(showLoading());
        HttpService.postRequest(API_URL.RESTORE_PROMPT + "/" + prompt.id, {}).then(
            (res: any) => {
                dispatch(hideLoading());
                Toast(`Prompt "${prompt.name}" restored successfully.`, "success");
                setTimeout(() => {
                    getPrompts();
                }, 1000);
            },
            (err: any) => {
                dispatch(hideLoading());
                Toast(err.message, "error");
            }
        )
    }

    const addPrompt = (type: boolean) => {
        setPrompt(promptObj);
        setIsOpenPromptStudio(true);
        if(type) {
            setUserDefinedPromptType(true);
        }
    }

    const runPrompt = (prompt: any) => {
        if (authProject?.id) {
            sessionStorage.setItem(PROMPT_LIBRARY_STATE_KEY, JSON.stringify({
                projectId: authProject.id,
                filterText: promptPayload.filterText,
                searchField: promptPayload.searchField,
                promptType: promptPayload.promptType,
                createdBy: promptPayload.createdBy,
                catIds: promptPayload.catIds,
                updatedBy: (promptPayload as any).updatedBy || [],
                pageIndex: pagination.pageIndex,
                pageSize: pagination.pageSize,
                searchText,
                // viewPublished: promptTab === 1 ? true : false,
                promptTab: promptTab
            }));
        }
        navigate('/rundocument', { state: { id: prompt.id, text: prompt.text, promptType: prompt.promptType, jsonOutput: prompt.jsonOutput, validations: prompt.validations } });
    }

    const addValidationCases = (pId: any, pCases: any, show: boolean) => {
        setValidationCases({
            id: pId,
            validations: pCases ? pCases : [],
            isShow: show
        })
        setIsOpenValidationCases(true);
    }

    const makeHref = (page: any) => {
        return `./prompt/${page}`;
    }

    const pageChange = (event: any) => {
        getPrompts(event, pagination.pageSize);
    }

    const onSelect = (event: any) => {
        const newOption = parseInt(event.target.value, 10);
        getPrompts(1, newOption);
    }

    const getTopItem = () => {
        return 1 + pagination.pageSize * (pagination.pageIndex - 1);
    }

    const getGaugePercent = (item: any) => {
        const score = Number(item?.score);
        const categoryScoreLength = Array.isArray(item?.categoryScore) ? item.categoryScore.length : 0;
        const maxScore = categoryScoreLength * 5;
        if (!Number.isFinite(score) || maxScore <= 0) {
            return 0;
        }
        const percent = score / maxScore;
        if (!Number.isFinite(percent)) {
            return 0;
        }
        return Math.min(Math.max(percent, 0), 1);
    }

    const openVersionHistory = (prompt: any) => {
        setPrompt(prompt);
        setIsOpenPromptVersionHistory(true)
    }

    const handleCheckbox = (prompt: any, checked: boolean) => {
        setPromptList((prev: any[]) =>
            prev.map((item: any) =>
                item.id === prompt.id ? { ...item, isSelected: checked } : item
            )
        );

        setSelectedPromptIds((prev: any[]) => {
            if (checked) {
                if (prev.includes(prompt.id)) {
                    return prev;
                }
                return [...prev, prompt.id];
            }
            return prev.filter((id: any) => id !== prompt.id);
        });
    }

    const bulkPublish = () => {
        if (selectedPromptIds.length === 0) {
            Toast("Please select at least one prompt to publish.", "warning");
            return;
        }
        dispatch(showLoading());
        HttpService.postRequest(API_URL.POST_BULK_PUBLISH_PROMPT, { listOfPromptsToPublish: selectedPromptIds }).then(
            (res: any) => {
                Toast('All selected prompts have been published successfully.', "success");
                getPrompts(pagination.pageIndex, pagination.pageSize, 0);
                dispatch(hideLoading());
            }
        ).catch((err: any) => {
            Toast("An error occurred while publishing the selected prompts.", "error");
            dispatch(hideLoading());
        }
        );
    }

    useEffect(() => {
        if (isLoad && authProject && authProject.id) {
            getPrompts(pagination.pageIndex, pagination.pageSize);
            setIsLoad(false);
        }
    }, [isLoad]);

    useEffect(() => {
        if (authProject && authProject.id) {
            let saved = null;
            try {
                const savedJson = sessionStorage.getItem(PROMPT_LIBRARY_STATE_KEY);
                if (savedJson) {
                    const parsed = JSON.parse(savedJson);
                    if (parsed.projectId === authProject.id) {
                        saved = parsed;
                    }
                }
            } catch {}

            if (saved) {
                sessionStorage.removeItem(PROMPT_LIBRARY_STATE_KEY);
                isRestoringStateRef.current = true;
                setPromptTab(saved.promptTab || 0);
                setSearchText(saved.searchText || '');
                promptPayload.projectId = authProject.id;
                promptPayload.filterText = saved.filterText || '';
                promptPayload.searchField = saved.searchField || 'name';
                promptPayload.promptType = saved.promptType || [];
                promptPayload.createdBy = saved.createdBy || [];
                promptPayload.catIds = saved.catIds || [];
                (promptPayload as any).updatedBy = saved.updatedBy || [];
                setPromptPayload({ ...promptPayload });
                const tabFromSaved = saved.promptTab;
                getPrompts(saved.pageIndex, saved.pageSize, tabFromSaved);
                setTimeout(() => { isRestoringStateRef.current = false; }, 0);
            } else {
                promptPayload.filterText = '';
                promptPayload.searchField = 'name';
                promptPayload.promptType = [];
                promptPayload.createdBy = [];
                promptPayload.catIds = [];
                setPromptPayload({ ...promptPayload });
                getPrompts();
            }
        }
    }, [authProject]);

    useEffect(() => {
        if (isPromptDeleted && authProject && authProject.id) {
            getPrompts();
            setIsPromptDeleted(false);
        }
    }, [isPromptDeleted]);

    useEffect(() => {
        if (authUser && authUser.privileges) {
            setIsEditAllPrompts(authUser.privileges.includes(Privilege[Privilege.EDIT_ALL_PROMPTS]));
            setIsDeleteAllPrompts(authUser.privileges.includes(Privilege[Privilege.DELETE_ALL_PROMPTS]));
        } else {
            setIsEditAllPrompts(false);
            setIsDeleteAllPrompts(false);
        }
    }, [authUser]);

    useEffect(() => {
        if (isInitialPromptTabEffect.current) {
            isInitialPromptTabEffect.current = false;
            return;
        }
        if (isRestoringStateRef.current) {
            return;
        }
        if (authProject && authProject.id) {
            getPrompts();
        }
    }, [promptTab]);
    
    const onChangeTab = (event: any) => {
        setPromptTab(event);
    }

    return (
        <>
            <div className='pt-10 pl-20 pr-20 pb-10' data-component="PromptLibrary">
                <div className="wk-row mb-15">
                    <div className="wk-col-6">
                        <h4>Prompt Library</h4>
                    </div>
                    <div className="wk-col-6 text-right">
                        <div className=''>
                            {selectedPromptIds.length > 0 && (
                                authUser?.privileges.includes(Privilege[Privilege.PUBLISH_PROMPT]) && (
                                    <ButtonField size={'small'}>
                                        <button type="button" onClick={() => bulkPublish()}>Publish Selected Prompts ({selectedPromptIds.length})</button>
                                    </ButtonField>
                                )
                            )}
                            <ButtonField size={'small'}>
                                <button type="button" className='ml-10' onClick={() => addPrompt(false)}>Create Prompt</button>
                            </ButtonField>
                            <ButtonField size={'small'}>
                                <button type="button" className='ml-10' onClick={() => addPrompt(true)}>Create Guided Prompt</button>
                            </ButtonField>
                        </div>
                    </div>
                </div>
                <div className="wk-row">
                    <div className="wk-col-12">
                        <PromptLibraryFilter data={{ promptPayload, setPromptPayload, getPrompts, facets, searchText, setSearchText, pagination, setSelectedPromptIds, promptTab, onChangeTab, isDeleteAllPrompts }} />
                    </div>
                </div>
                <div className="wk-row custom-container-req" style={{ height: 'calc(100vh - 271px)' }}>
                    <div className="wk-col-3" style={{ height: 'calc(100vh - 271px)' }}>
                        <FacetsFilter data={{ promptPayload, setPromptPayload, getPrompts, facets, setFecets, pagination }} />
                    </div>
                    <div className="wk-col-9">
                        {promptList.length > 0 ? (
                            <div className="scroll-p scroll pl-0 position-relative" id="scrollReq" style={{ height: 'calc(100vh - 271px)' }}>
                                {promptList.map((prompt: any, index: any) => (
                                    <article className={`card-primary${prompt.isSelected ? ' selected' : ''}`} key={index}>
                                        <div className="card-primary__content">
                                            <h3 className="card-primary__title clearfix flex space-between align-center" style={{ color: '#005b92' }}>
                                                <div className='flex1 flex align-center'>
                                                    {promptTab !== 3 && authUser?.privileges.includes(Privilege[Privilege.PUBLISH_PROMPT]) && 
                                                        (<span className="mr-10">
                                                            <CheckboxField label="">
                                                                <input
                                                                    name="checkbox1"
                                                                    type="checkbox"
                                                                    disabled={prompt.status === 'PUBLISHED'}
                                                                    checked={prompt.isSelected}
                                                                    onChange={(event: any) => handleCheckbox(prompt, event.target.checked)}
                                                                    />
                                                            </CheckboxField>
                                                        </span>
                                                        )
                                                    }
                                                    <span>
                                                        {prompt.name} 
                                                    </span>
                                                     {promptTab !== 3 && (
                                                         <span className="version-pill ml-10 mr-10" title='Current Version'>V{prompt.version} - {prompt.status}</span>
                                                        )}
                                                        {
                                                        <span className="version-pill mr-10" title='Current Version'>Prompt Id: {prompt.id}</span>
                                                        }

                                                </div>
                                                <span className=''>
                                                    <span className="mt-10 card-primary__tag">
                                                        <span className='mr-10 cursor' onClick={() => openVersionHistory(prompt)}>
                                                            <Iconsvg name="layer" title="Version History"></Iconsvg>
                                                        </span>
                                                        {promptTab !== 3 && (
                                                            <>
                                                                <span className="badge rounded-pill text-bg-light border test cursor-pointer mr-10" onClick={() => addValidationCases(prompt.id, prompt.validations, false)}><span className='wk-weight-400 wk-size-1'>Validation : {prompt.validations ? prompt.validations.length : 0}</span></span>
                                                                {(prompt.createdBy == authUser?.username || isEditAllPrompts) && (
                                                                    <>
                                                                    <span className="cursor-pointer" onClick={() => editPrompt(prompt, true)}>
                                                                    <span className='text-body-secondary'>Score</span> : <GaugeChart style={{ display: 'inline-block', width: '50px' }}
                                                                        id="gauge-chart2"
                                                                        nrOfLevels={3}
                                                                        colors={["red", "orange", "green"]}
                                                                        arcWidth={0.3}
                                                                        arcsLength={[0.3, 0.5, 0.2]}
                                                                        percent={getGaugePercent(prompt)}
                                                                        textColor={'black'}
                                                                        hideText={true}
                                                                    /></span>
                                                                    </>
                                                                )}
                                                            </>
                                                        )}        
                                                    </span>
                                                </span>
                                            </h3>

                                            <p className="card-primary__description">{prompt.text}</p>
                                            <div className="card-primary__category">
                                                <Iconsvg name="flag" color="#EFAB40" size={14}></Iconsvg>{" "}<span className='mr-10 badge text-bg-light type'><span className='align-middle wk-size-1 wk-weight-400'>{prompt.promptType?.name}</span></span> {" "}
                                                {/* {prompt.tags.length > 0 ? <Iconsvg name="tags" color="#EFAB40" size={14}></Iconsvg> : null}{" "}{prompt.tags.length > 0 ? prompt.tags.map((tag: any, index: any) => (
                                                    <span key={index} className='mr-5 badge text-bg-light align-middle'>
                                                        <span className='align-middle wk-primary-blue type'>{tag.taxonomyType}</span> <Iconsvg name="chevron-right" color="#EFAB40" size={10}></Iconsvg> <span className='align-middle wk-size-1 wk-weight-400'>{tag.name}</span>
                                                    </span>
                                                )) : null}
                                                <br /> */}
                                                <Tags data={{ tags: prompt?.tags }} />
                                            </div>
                                            <div className='clearfix'>
                                                <span className='float-end'>
                                                    {promptTab !== 3 && (
                                                        <>
                                                            <button type="button" className="btn btn btn-outline-light mr-5"
                                                                style={{ padding: '.25rem .5rem', fontSize: '.75rem', color: '#9A67F3'}}
                                                                onClick={() => runPrompt(prompt)}>
                                                                Run Doc
                                                            </button>
                                                            <button type="button" className="btn btn btn-outline-light"
                                                                style={{ padding: '.25rem .5rem', fontSize: '.75rem', color: '#9A67F3' }}
                                                                onClick={() => addValidationCases(prompt.id, prompt.validations, true)}>
                                                                    <div className="flex">
                                                                        <div className="flex direction-column align-items-center">
                                                                            <Iconsvg name="plus" color='#9A67F3' size={12}></Iconsvg>
                                                                            <Iconsvg name="minus" color='#9A67F3' size={12}></Iconsvg>
                                                                        </div>
                                                                        <div className='ml-5'>
                                                                        Validation    
                                                                        </div>
                                                                    </div>
                                                            </button>
                                                            {(prompt.createdBy == authUser?.username || isEditAllPrompts) && (
                                                                <ButtonFieldIcon>
                                                                    <button type="button" onClick={() => editPrompt(prompt, false)} title="Edit Prompt">
                                                                        <Iconsvg name="pencil" color='#9A67F3'></Iconsvg>
                                                                    </button>
                                                                </ButtonFieldIcon>
                                                            )}
                                                            { isDeleteAllPrompts && (
                                                                <ButtonFieldIcon>
                                                                    <button type="button" onClick={() => deletePromptConfirm(prompt)} title="Delete Prompt">
                                                                        <Iconsvg name="trash" color='#9A67F3'></Iconsvg>
                                                                    </button>
                                                                </ButtonFieldIcon>
                                                            )}
                                                        </>
                                                    )}

                                                    {(promptTab == 3 && isDeleteAllPrompts) && (
                                                        <>
                                                            <ButtonFieldIcon>
                                                                <button type="button" onClick={() => permenantdeletePromptConfirm(prompt)} title="Delete Permanently">
                                                                    <Iconsvg name="trash" color='#9A67F3'></Iconsvg>
                                                                </button>
                                                            </ButtonFieldIcon>
                                                            <ButtonFieldIcon>
                                                                <button type="button" onClick={() => restorePrompt(prompt)} title="Restore Prompt">
                                                                    <Iconsvg name="refresh" color='#9A67F3'></Iconsvg>
                                                                </button>
                                                            </ButtonFieldIcon>
                                                        
                                                        </>
                                                    )}

                                                </span>
                                                <div className='pt-10' style={{ fontSize: '12px' }}>
                                                    Created by: <span className='card-primary__stamp'>{prompt.createdBy} | {moment(prompt.created).utc().format('MM-DD-YYYY HH:mm:ss [UTC]')}</span> <br />
                                                    Last updated by: <span className='card-primary__stamp'>{prompt.updatedBy} | {moment(prompt.updated).utc().format('MM-DD-YYYY HH:mm:ss [UTC]')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </article>
                                ))}
                            </div>
                        ) : (
                            <div className='custom-container-req w-100'>
                                <table className='center'>
                                    <tbody><tr>
                                        <td>
                                            <h5 className="wk-weight-400 mt-30 text-center">
                                                No record found.
                                            </h5>
                                            {/* <h5 className="wk-weight-400 mt-30 text-center">
                                        Create new Prompt by Clicking on below buttons.
                                    </h5>
                                    <div className="mt-20">
                                        <ButtonField iconPosition={'right'} mode={'ghost'}>
                                            <button type="button" className="rounded-5 text-center wk-size-4 mr-30" style={{ minWidth: '260px', display: 'block' }} onClick={() => addPrompt(false)}>
                                                Create Prompt
                                                <Iconsvg name="arrow-right"></Iconsvg>
                                            </button>
                                        </ButtonField>
                                        <ButtonField iconPosition={'right'} mode={'ghost'}>
                                            <button type="button" className="rounded-5 text-center wk-size-4" style={{ minWidth: '260px', display: 'block' }} onClick={() => addPrompt(true)}>
                                                Create Guided Prompt
                                                <Iconsvg name="arrow-right"></Iconsvg>
                                            </button>
                                        </ButtonField>
                                    </div> */}
                                        </td>
                                    </tr></tbody>
                                </table>
                            </div>
                        )}
                        <div className="mt-5">
                            {promptList.length > 0 ? (
                                <PaginationBar>
                                    <PaginationBarLeft>
                                        {getTopItem()} - {(pagination.pageSize * pagination.pageIndex) > pagination.totalCount ? pagination.totalCount : (pagination.pageSize * pagination.pageIndex)} of{' '}
                                        {pagination.totalCount} results{' '}
                                    </PaginationBarLeft>
                                    <PaginationBarRight>
                                        <SelectField size="small">
                                            <select onChange={(event: any) => onSelect(event)} value={pagination.pageSize}>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        </SelectField>
                                        <Pagination
                                            pageIndex={pagination.pageIndex}
                                            pageCount={pagination.pageCount}
                                            controlMode='controlled'
                                            onUserRequest={(event: any) => pageChange(event)}></Pagination>
                                    </PaginationBarRight>
                                </PaginationBar>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
            {isOpenConfirm  && <ConfirmPrompt data={{ isOpenConfirm, setIsOpenConfirm, prompt, setIsPromptDeleted, getPrompts }} />}
            {isOpenPromptStudio && <PromptStudio data={{ isOpenPromptStudio, setIsOpenPromptStudio, prompt, setPrompt, setIsLoad, promptObj, userDefinedPromptType, setUserDefinedPromptType, isOpenImproveScore, setIsOpenImproveScore }} />}
            {isOpenValidationCases && <AddDeleteValidationCases data={{ isOpenValidationCases, setIsOpenValidationCases, validationCases, setIsLoad }} />}
            {isOpenPromptVersionHistory && <PromptVersionHistory data={{ isOpenPromptVersionHistory, setIsOpenPromptVersionHistory, prompt }} />}
             {isOpenDeleteConfirm && <DeleteConfirm data={{ isOpenDeleteConfirm, setIsOpenDeleteConfirm, deleteItem, message: `Are you sure you want to delete this prompt permanently?` }} />}
        </>
    )
}

export default PromptLibrary;